module.exports = ".ngx-datatable.material.datatable-header\n.datatable-header-cell-label {\nfont-weight:bold;\n}\n        "